import JobDetailsWidget from './JobDetailsWidget';
import JobListWidget from './JobListWidget';
import CheckBoxMenu from './CheckBoxMenu';

export {
    JobDetailsWidget,
    JobListWidget,
    CheckBoxMenu
};



// WEBPACK FOOTER //
// ./plugins/jobs/web_client/views/index.js